import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { accessLocalStorage, readContacts, exportDeleteEndpoints } from '../../services';

import PbxContext from '../../context/PbxContext';
import '../../libs/bulma.min.css';

import Loading from '../../components/Loading/LoadingModule';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faEye, faPlus, faFilter, faTrash } from '@fortawesome/free-solid-svg-icons';

function ContactsList() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsChangeFormElements, toggleIsHidden, setItemsSelectedToEdit } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const [loading, setLoading] = useState(true);
  const [contacts, setContacts] = useState(() => []);
  const [contactsSelected, setContactsSelected] = useState([]);
  const [disable, setDisable] = useState(true);

  const history = useHistory();

  const fetchContacts = async () => {
    const getContactList = await readContacts();
    // addr: "Rio de Janeiro 123"
    // alias: "Interface"
    // cnpj: "11222333000199"
    // comm: "Empresa de suporte técnico"
    // compname: "JFNN"
    // id: 1
    // mail: "interfacedesk@teste.com"
    // namefantasy: "Interfacedesk"
    // updated: "2023-05-09T19:18:32.492Z"
    //

    if(getContactList === undefined) setLoading(true);
    setContacts(getContactList);
    setLoading(false);

    return true;
  };


  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    // if (dataUser && role !== 'root') return history.push('/home');

    const contactsFetched = await fetchContacts();
    return contactsFetched;
  }, []);

  const filterListContacts = async (data) => {
    const { name, value } = data;

    // if(contacts.length === 0 && value.length > 0) validateUserLogged();

    const filtredContacts = contacts.filter((contact) => contact[`${name.split('-')[0]}`].includes(value));

    setContacts(filtredContacts);
    if(value === '') validateUserLogged();
  };

  useEffect(() => {
    let cancel = false;
    
    if (cancel) return;
    validateUserLogged();

    return () => {
      cancel = true
    };
  }, [validateUserLogged]);

  return (
    <div>
      {
        loading ?
          <Loading />
        :
        <div>
          <div className="columns">
            <div className="column is-half is-offset-one-quarter has-text-centered">
              <strong className="is-size-3">AGENDA</strong>
              <hr className="dropdown-divider"/>
            </div>
          </div>
          <article id="alert-endpoints-not-delete" name="alert-endpoints-not-delete" className="column is-half is-offset-one-quarter message is-danger is-hidden">
            <div className="message-header">
              <p>Atenção!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-endpoints-not-delete') }></button>
            </div>
            <div className="message-body">
              Não foi possível deletar os ramais selecionados.
            </div>
          </article>
          <article id="alert-confirm-endpoints-delete" name="alert-confirm-endpoints-delete" className="column is-half is-offset-one-quarter message is-danger is-hidden">
            <div className="message-header">
              <p>Atenção!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-confirm-endpoints-delete') }></button>
            </div>
            <div className="message-body">
              Tem certeza que quer deletar os ramais selecionados?
            </div>
            <br />
          <div className="columns">
            <div className="column is-half is-offset-one-quarter has-text-centered is-active">
              <button className="button is-danger is-half mx-3 px-5" type="submit" onClick={ () => handleClickDelete() }>
                    <span className="icon">
                      <FontAwesomeIcon icon={ faTrash } fixedWidth />
                    </span>
                    <span>
                      Confirmar
                    </span>
              </button>
              <button className="button is-info is-half mx-3 px-5" type="submit" onClick={ () => {
                toggleIsHidden('#alert-confirm-endpoints-delete')
                toggleIsHidden('#buttons')
              }}>
                    <span className="icon">
                      <FontAwesomeIcon icon={ faTrash } fixedWidth />
                    </span>
                    <span>
                      Cancelar
                    </span>
              </button>
            </div>
          </div>
          </article>
          <article id="alert-create-endpoints" name="alert-create-endpoints" className="column is-half is-offset-one-quarter message is-warning is-hidden">
            <div className="message-header">
              <p>Atenção!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-create-endpoints') }></button>
            </div>
            <div className="message-body">
              Ramais deletados com sucesso!
            </div>
          </article>
          
          <button className="button is-small is-info is-half mx-3 px-4 mb-2" type="submit" onClick={ () => history.push('/agenda/novo') }>
            <span className="icon">
              <FontAwesomeIcon icon={ faPlus } fixedWidth />
            </span>
            <span>
              Novo
            </span>
          </button>
          <div className="table-container is-flex-wrap-wrap">
            <table id="tableCalls" className="table is-hoverable is-striped is-fullwidth">  
              <thead>
                  <tr className='is-size-7 has-text-centered has-background-link-light'>
                  <th className='th-interactive is-clickable' scope="col">
                    <span className="icon" onClick={() => { toggleIsHidden('#compname-input')}}><FontAwesomeIcon icon={ faFilter } fixedWidth /></span>
                    <span className="mt-5"> Razão Social </span><input className="input is-small is-2 is-hidden" name="compname-input" id="compname-input" type="text" placeholder="Filtar por Razão Social" onChange={ (e) => filterListContacts(e.target)}/>
                  </th>
                  <th className='th-interactive is-clickable' scope="col">
                    <span className="icon" onClick={() => { toggleIsHidden('#namefantasy-input')}}><FontAwesomeIcon icon={ faFilter } fixedWidth /></span>
                    <span className="mt-5"> Nome Fantasia </span><input className="input is-small is-2 is-hidden" name="namefantasy-input" id="namefantasy-input" type="text" placeholder="Filtar por Nome Fantasia" onChange={ (e) => filterListContacts(e.target)}/>
                  </th>
                  <th className='th-interactive is-clickable' scope="col">
                    <span className="icon" onClick={() => { toggleIsHidden('#cnpj-input')}}><FontAwesomeIcon icon={ faFilter } fixedWidth /></span>
                    <span className="mt-5"> CNPJ/CPF </span><input className="input is-small is-2 is-hidden" name="cnpj-input" id="cnpj-input" type="text" placeholder="Filtar por CNPJ/CPF" onChange={ (e) => filterListContacts(e.target)}/>                    
                  </th>
                  <th className='th-interactive is-clickable' scope="col">
                    <span className="icon" onClick={() => { toggleIsHidden('#mail-input')}}><FontAwesomeIcon icon={ faFilter } fixedWidth /></span>
                    <span className="mt-5"> E-mail </span><input className="input is-small is-2 is-hidden" name="mail-input" id="mail-input" type="text" placeholder="Filtar por e-mail" onChange={ (e) => filterListContacts(e.target)}/>  
                  </th>
                  <th className='th-interactive is-clickable' scope="col">
                    <span className="icon" onClick={() => { toggleIsHidden('#alias-input')}}><FontAwesomeIcon icon={ faFilter } fixedWidth /></span>
                    <span className="mt-5"> Apelido </span><input className="input is-small is-2 is-hidden" name="alias-input" id="alias-input" type="text" placeholder="Filtar por apelido" onChange={ (e) => filterListContacts(e.target)}/>                      
                  </th>
                  <th className='th-interactive is-clickable' scope="col"></th>
                  </tr>
              </thead>
              <tbody>
              {
                contacts.map((contact) => {
                  const { id, compname, namefantasy, cnpj, mail, alias } = contact;
                  return (
                    <tr className='is-size-7 has-text-centered' key={ id }>
                      <td>{compname}</td>
                      <td>{namefantasy}</td>
                      <td>{cnpj}</td>
                      <td>{mail}</td>
                      <td>{alias}</td>
                      <td>
                        <button
                          className="button is-small is-success" type="submit"
                          onClick={() => {
                            setItemsSelectedToEdit([id]);
                            history.push('/agenda/contato/id');
                          }}
                        >
                          <span className="icon">
                            <FontAwesomeIcon icon={ faPen } fixedWidth />
                          </span>
                        </button>
                        <button
                          className="button is-small is-info ml-2" type="submit"
                          onClick={() => {
                            setItemsSelectedToEdit([id]);
                            history.push('/agenda/contato/visualizar');
                          }}
                        >
                          <span className="icon">
                            <FontAwesomeIcon icon={ faEye } fixedWidth />
                          </span>
                        </button>
                      </td>
                    </tr>)
                })
              }
              </tbody>
            </table>
          </div>
        </div>
      }
    </div>
  );
}

export default ContactsList;
